import { Component, Input, OnInit } from "@angular/core"
import { UserService } from "../../../services/user.service"
import { CardComponent } from "../card.component"

@Component({
    selector: "app-collection-card",
    templateUrl: "./collection-card.component.html",
    styleUrls: ["./collection-card.component.less"],
})
export class CollectionCardComponent extends CardComponent implements OnInit {
    @Input() public gtmDataCardNumber: number

    constructor(public userService: UserService) {
        super(userService)
    }

    public ngOnInit() {
        this.showAsCollection = true
    }
}
